import React, { useState } from 'react';
import * as EmailValidator from "email-validator";
import '../../Styles/LoginPage/Login.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

function SendMailPass() {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [confirmMessage, setConfirmMessage] = useState('');

  function handleSubmit() {
    if (EmailValidator.validate(email)) {
      fetch('/api/sendMailPassword', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ email }),
      })
        .then(async (res) => {
          if (res.status === 401) {
            setConfirmMessage('');
            setErrorMessage(await res.text());
          }
          if (res.status === 200) {
            setErrorMessage('');
            setConfirmMessage(await res.text());
          }
        })
        .catch(err => console.log(err));
    } else {
      setConfirmMessage('');
      setErrorMessage('Votre adresse mail est invalide');
    }
  }

  return (
    <div className="lf-root">
      <div className="lf-form">

        <div className="lf-field">
          <label htmlFor="fp-email" className="lf-field__label">Votre adresse e-mail</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faEnvelope} /></span>
            <input
              type="text"
              className="lf-field__input"
              id="fp-email"
              placeholder="votre@email.com"
              autoComplete="email"
              onChange={e => setEmail(e.target.value)}
            />
          </div>
        </div>

        <button type="button" className="lf-submit" onClick={handleSubmit}>
          Envoyer le lien de réinitialisation
        </button>

        {errorMessage && <div className="lf-error" role="alert">{errorMessage}</div>}
        {confirmMessage && <div className="lf-success">{confirmMessage}</div>}

        <p className="lf-switch">
          <Link to="/login" className="lf-switch__link">← Retour à la connexion</Link>
        </p>
      </div>
    </div>
  );
}

export default SendMailPass;
